module.exports = __webpack_public_path__ + "static/media/7.7ffb9cd8.jpg";